var map = {
	"./author.svg": [
		4735,
		250,
		735
	],
	"./close.svg": [
		3658,
		250,
		658
	],
	"./play.svg": [
		2524,
		250,
		524
	],
	"./reload.color.svg": [
		3229,
		250,
		610
	],
	"./right.svg": [
		2240,
		250,
		240
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 8948;
module.exports = webpackAsyncContext;